<div class="flex justify-content-center align-items-center font-bold text-xl" *ngIf="onExtendedMobile()">
	{{ titleId | translate }}
</div>
<div class="layout-content p-0 pt-3" [ngClass]="layoutMarginResponsive()">
	<app-site-selector></app-site-selector>
	<div class="grid mt-0">
		<div *ngIf="site === undefined" class="col-12 pb-0">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<i class="pi cm-alert text-lg text-yellow-700"></i>
				<p-tag [value]="('NO_SITE_SCENARY_ALERT' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
		</div>
		<div class="col-12">
			<app-scenery-tab-group></app-scenery-tab-group>
		</div>
	</div>
</div>